import { BenchmarkPanel } from '@/modules/sentinel-workspace/benchmark/benchmark-panel';

export default function SentinelBenchmarkRoute() {
  return (
    <div className="flex h-[calc(100dvh-3rem)] md:h-screen w-full overflow-hidden">
      <BenchmarkPanel />
    </div>
  );
}
